import React from "react";
import AllApplicants from "./Applicant/AllApplicants";
import JobBoards from "./Applicant/JobBoards";
import { NewTab, PageTabAdv } from "../../../components";
import Campaigns from "./Applicant/Campaigns";
import InternalSubmissions from "./Applicant/InternalSubmissions";
import InterviewFollowup from "./Applicant/InterviewFollowup";
import Confirmed from "./Applicant/Confirmed";
import { useModuleAccess } from "../../../hooks";
import BlockedApplicants from "./Applicant/BlockedApplicants";
import { useSelector } from "react-redux";

const Applicants = () => {
  const { user } = useSelector((state) => state.auth);
  const applicantsMenus = [
    {
      title: "All Applicants",
      page: <AllApplicants />,
      type: "main",
      id: "applicants_allapplicants",
    },
    {
      title: "Job Boards",
      page: <JobBoards />,
      type: "main",
      id: "applicants_jobboards",
    },
    user?.data?.role?.type === 1 && {
      title: "Blocked Applicants",
      page: <BlockedApplicants />,
      type: "main",
      id: "applicants_blockedapplicants",
    }
  ].filter(Boolean);
  const filteredTabs = useModuleAccess({
    allTabs: applicantsMenus,
    parentId: "applicants",
  });
  return (
    <div className="flex flex-1 h-full ">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="applicants"
      />
    </div>
  );
};

export default Applicants;
